import { render, staticRenderFns } from "./organization-datasource-view.vue?vue&type=template&id=eb6b1b44"
import script from "./organization-datasource-view.vue?vue&type=script&lang=js"
export * from "./organization-datasource-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports